import { useQuery } from '@tanstack/react-query';

import { getCompanyLegalEntity } from '@/services/financial';
import { CACHE_TTL } from '@/services/constants';
import { useImpersonation } from '@/contexts/ImpersonationContext';

/**
 * Dados jurídicos do vendedor, vindos de `/financial/company/legal-entity/`.
 *
 * Não notifica erro: a aba de pessoa jurídica é um card secundário do perfil, e
 * um toast vermelho ao abrir a página por causa dele seria ruído. Falhando, a
 * aba renderiza o estado vazio.
 */
export default function useCompanyLegalEntity() {
  const { impersonatedUserId } = useImpersonation();
  const isImpersonating = !!impersonatedUserId;

  const {
    data: legalEntity,
    isLoading: isLoadingLegalEntity,
    isError: isErrorLegalEntity,
  } = useQuery({
    queryKey: ['financial.company.legal-entity'],
    queryFn: () => getCompanyLegalEntity(),
    enabled: !isImpersonating,
    staleTime: CACHE_TTL,
  });

  return { legalEntity, isLoadingLegalEntity, isErrorLegalEntity };
}
